module.exports = __webpack_public_path__ + "img/room08_clipboard.ab8a684b.png";